'use client';

import ArrowBack from '@/assets/vectors/ArrowBack';
import HandTap from '@/assets/vectors/HandTap';
import Button from '@/components/button/Button';
import dictionary from '@/utils/dictionary';
import { AnimatePresence, motion } from 'framer-motion';
import { usePathname } from 'next/navigation';
import { useSyncExternalStore } from 'react';
import styles from './navigation_call_to_action.module.scss';

const subscribeToScroll = (callback: () => void) => {
    window.addEventListener('scroll', callback, { passive: true });
    window.addEventListener('resize', callback);
    return () => {
        window.removeEventListener('scroll', callback);
        window.removeEventListener('resize', callback);
    };
};
const getScrollVisibility = () => window.scrollY > window.innerHeight / 2;
const getServerScrollVisibility = () => false;

export default function NavigationCallToAction() {
    const pathname = usePathname();
    const scrolled = useSyncExternalStore(subscribeToScroll, getScrollVisibility, getServerScrollVisibility);
    const isHome = pathname === '/';
    const currentVariant = isHome
        ? { label: dictionary.global.get_in_touch, startIcon: HandTap, href: '#section_contact' }
        : { label: dictionary.global.back, startIcon: ArrowBack, href: '/' };

    return (
        <AnimatePresence mode="wait">
            <motion.div
                className={styles.button_wrapper}
                key={currentVariant.label}
                variants={{
                    visible: {
                        opacity: 1, width: 'auto', y: 0,
                        transition: { type: 'spring', damping: 14, stiffness: 230 },
                    },
                    invisible: { opacity: 0, width: 0, y: isHome ? 20 : -20 },
                    exit: {
                        opacity: 0, width: 0, y: isHome ? 20 : -20,
                        transition: { duration: 0.3, ease: 'easeIn' },
                    },
                }}
                initial="invisible"
                animate={!isHome || scrolled ? 'visible' : 'invisible'}
                exit="invisible"
            >
                <Button className={styles.button} size="medium" loadingLabel={dictionary.global.loading} {...currentVariant} />
            </motion.div>
        </AnimatePresence>
    );
}
